import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//helpers
import {getErrorResponse} from '@/utils/helpers';
import {IUserOrganizationSettingData, IUserSettingReqData} from '@/utils/types';
import {UserNotificationSettingService} from '@/utils/services';

// get user notification setting
export const userGetNotificationSettings = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_LIST,
	async (userId: number, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserOrganizationSettingData> =
				await UserNotificationSettingService.getAllNotificationSetting(userId);
			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

//update  user notification setting
export const userUpdateNotificationSettings = createAsyncThunk(
	ACTION_TYPE.NOTIFICATION_SETTING_UPDATE_LIST,
	async ({id, reqBody}: IUserSettingReqData, {rejectWithValue}) => {
		try {
			const userResponse: AxiosResponse<IUserOrganizationSettingData> =
				await UserNotificationSettingService.updateNotificationSetting(id, reqBody);
			return userResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
